import React from 'react';
import { Typography, Card, Row, Col, Space, Divider, Alert } from 'antd';
import { useTranslation } from 'react-i18next';
import {
  CheckCircleTwoTone,
  HeartTwoTone,
  GlobalOutlined,
  TeamOutlined,
  SafetyCertificateOutlined,
} from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

const AboutPage: React.FC = () => {
  const { t } = useTranslation();

  const highlights = [
    {
      icon: <SafetyCertificateOutlined />,
      title: t('about.highlights_transparency_title'),
      desc: t('about.highlights_transparency_desc'),
    },
    {
      icon: <TeamOutlined />,
      title: t('about.highlights_workers_title'),
      desc: t('about.highlights_workers_desc'),
    },
    {
      icon: <GlobalOutlined />,
      title: t('about.highlights_environment_title'),
      desc: t('about.highlights_environment_desc'),
    },
  ];

  return (
    <div style={{ padding: 24, maxWidth: 1000, margin: '0 auto' }}>
      <Title level={1}>{t('about.title')}</Title>
      <Paragraph style={{ fontSize: 16 }}>{t('about.subtitle')}</Paragraph>

      <Alert
        type="info"
        message={t('about.note')}
        showIcon
        style={{ margin: '16px 0' }}
      />

      <Card style={{ marginTop: 16 }}>
        <Title level={3}>{t('about.why_title')}</Title>
        <Paragraph>{t('about.why_p1')}</Paragraph>
        <Paragraph>{t('about.why_p2')}</Paragraph>
        <Paragraph>{t('about.why_p3')}</Paragraph>
      </Card>

      <Card style={{ marginTop: 16 }}>
        <Title level={3}>{t('about.how_title')}</Title>
        <Row gutter={[16, 16]}>
          {highlights.map((h, idx) => (
            <Col xs={24} md={8} key={idx}>
              <Space direction="vertical" size={8}>
                <div style={{ fontSize: 24 }}>{h.icon}</div>
                <Text strong>{h.title}</Text>
                <Text type="secondary">{h.desc}</Text>
              </Space>
            </Col>
          ))}
        </Row>
        <Divider />
        <Paragraph>{t('about.how_data_sources')}</Paragraph>
      </Card>

      <Card style={{ marginTop: 16 }}>
        <Title level={3}>{t('about.impact_title')}</Title>
        <Paragraph>{t('about.impact_p1')}</Paragraph>
        <Paragraph>{t('about.impact_p2')}</Paragraph>
      </Card>

      <Card style={{ marginTop: 16 }}>
        <Title level={3}>{t('about.join_title')}</Title>
        <Paragraph>
          <CheckCircleTwoTone twoToneColor="#52c41a" />{' '}
          {t('about.join_contribute')}
        </Paragraph>
        <Paragraph>
          <HeartTwoTone twoToneColor="#eb2f96" /> {t('about.join_feedback')}
        </Paragraph>
      </Card>
    </div>
  );
};

export default AboutPage;
